<template>
  <div id="consultarcontratowrapper">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres titulo="Contratos e Ordens de Fornecimento" :botoes="botoesHeader" breakpoint="xl" />
      </template>
      <b-card-body>
        <CardFiltrosBusca>
          <b-form @submit.prevent="filtrarCOFs" @reset.prevent="limparFiltros">
            <b-row>
              <b-col cols="6" lg="3">
                <b-form-group id="input-group-numero" label-size="md" label="Número">
                  <b-form-input v-model="filtros.numero"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="6" lg="3">
                <b-form-group id="input-group-ano" label-size="md" label="Ano">
                  <b-form-input v-model="filtros.ano"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="6">
                <b-form-group id="input-group-procedimentoOrigem" label-size="md" label="Procedimento de Origem"
                  label-for="input-filtroProcedimentoOrigem" label-class="text-left">
                  <b-form-select v-model="filtros.idProcedimentoOrigem" id="select-filtros-procedimentoOrigem"
                    :options="procedimentoOrigem">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group id="input-group-objeto" label-size="md" label="Objeto">
                  <b-form-input v-model="filtros.objeto"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group id="input-group-tipo" label-size="md" label="Tipo">
                  <b-form-select id="select-filtros-tipo" v-model="filtros.idTipo" :options="tipoContrato">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" lg="4">
                <b-form-group id="input-group-situacao" label-size="md" label="Situação">
                  <b-form-select id="select-filtros-situacao" v-model="filtros.situacao" :options="situacao">
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" xl="3">
                <default-form-validation-provider rules="" label="Valor mínimo">
                    <money class="form-control" v-model="filtros.valorMin" v-bind="vMoneyOptions"></money>
                </default-form-validation-provider>
              </b-col>
              <b-col cols="12" sm="6" xl="3">
                <default-form-validation-provider rules="" label="Valor máximo">
                    <money class="form-control" v-model="filtros.valorMax" v-bind="vMoneyOptions"></money>
                </default-form-validation-provider>
              </b-col>
              <!-- Adicionar Filtro de Situação e Valor -->
              <b-col cols="6" lg="2" class="pt-4">
                <b-button type="reset" variant="outline-secondary">
                  <font-awesome-icon icon="redo" class="mr-3" />Limpar
                </b-button>
              </b-col>
              <b-col cols="6" lg="2" class="pt-4">
                <b-button type="submit" :disabled="tableBusy">
                  <font-awesome-icon icon="search" class="mr-3" />Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </CardFiltrosBusca>
        <b-table :fields="fields" :items="items" :busy="tableBusy" :current-page="currentPage" hover no-border-collapse
          sort-by="" :sort-desc="true" striped stacked="xl" show-empty>
          <template #empty>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #emptyfiltered>
            <span>Não foram encontrados dados.</span>
          </template>
          <template #table-busy>
            <div class="text-center text-dark">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="loading-text">Carregando...</strong>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <b-dropdown class="d-sm-none" right no-caret>
              <template #button-content>
                <font-awesome-icon icon="bars" />
              </template>
              <b-dropdown-item @click="detalhesContrato(row.item.IdContrato)">
                <font-awesome-icon icon="eye" />
                <span>Detalhes</span>
              </b-dropdown-item>
              <b-dropdown-item @click="editarContrato(row.item)">
                <font-awesome-icon icon="edit" />
                <span>Editar</span>
              </b-dropdown-item>
              <b-dropdown-item @click="detalhesContrato(row.item.IdContrato, true)">
                <font-awesome-icon icon="trash" />
                <span>Excluir</span>
              </b-dropdown-item>
              <b-dropdown-item @click="toggleModalAnulacao(row.item.IdContrato)">
                <font-awesome-icon icon="ban" />
                <span>Anulação</span>
              </b-dropdown-item>
            </b-dropdown>
            <div class="actions-icons lgvert d-none d-sm-flex">
              <b-link class="text-dark" @click="detalhesContrato(row.item.IdContrato)">
                <font-awesome-icon icon="eye" />
                <div style="font-size: 12px">Detalhes</div>
              </b-link>
              <b-link class="text-dark" @click="editarContrato(row.item)">
                <font-awesome-icon icon="edit" />
                <div style="font-size: 12px">Editar</div>
              </b-link>
              <b-link class="text-dark" @click="detalhesContrato(row.item.IdContrato, true)">
                <font-awesome-icon icon="trash" />
                <div style="font-size: 12px">Excluir</div>
              </b-link>
              <b-link class="text-dark" @click="toggleModalAnulacao(row.item.IdContrato)">
                <font-awesome-icon icon="ban" />
                <div style="font-size: 12px">Anulação</div>
              </b-link>
            </div>
          </template>
        </b-table>
        <table-pagination v-if="totalRows > 10" :total-rows="totalRows" :per-page="10" @pageChange="pageChange" />
      </b-card-body>
    </b-card>
    <modal-anular-contrato v-if="exibirModalAnulacao" :idContrato="idContratoSelecionado.toString()"
      @fecharModal="toggleModalAnulacao" @refresh="atualizarLista"></modal-anular-contrato>
    <modal-importar-contrato v-if="exibirModalImportacao" @fecharModal="toggleModalImportacao" @refresh="atualizarLista"/>
  </div>
</template>

<script lang="ts">
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import CardFiltrosBusca from '@/components/shared/CardFiltrosBusca.vue';
import HeaderSagres from '@/components/shared/HeaderSagres.vue';
import contratoService from '@/services/licitacoes/contratoService';
import { store } from "@/store";
import { BotaoSagres } from '@/types/botao-sagres';
import { FiltrosContratos } from "@/types/licitacoes/contratos/filtros-contratos";
import { fieldsContratosConsulta } from '@/types/licitacoes/contratos/fields-contratos';
import { TableField } from '@/types/table-field';
import { UtilsTS } from '@/utilsts';
import { mixins } from 'vue-class-component';
import { Component, Vue } from 'vue-property-decorator';
import { ContratoResumido } from "@/types/licitacoes/contratos/contrato-resumido";
import { Money } from 'v-money'
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue'
import ModalAnularContrato from "@/components/licitacoes/contratos/modais/ModalAnularContrato.vue";
import ModalImportarContrato from "@/components/licitacoes/contratos/modais/ModalImportarContrato.vue";

const CompProps = Vue.extend({
  name: 'ConsultarContratosOF',
  components: { CardFiltrosBusca, DefaultFormValidationProvider, HeaderSagres, TablePagination, Money, ModalAnularContrato, ModalImportarContrato }
})

@Component
export default class ConsultarContratosOF extends mixins(UtilsTS, CompProps) {
  fields: TableField[] = fieldsContratosConsulta
  items: ContratoResumido[] = []
  filtros: FiltrosContratos = new FiltrosContratos()

  tipoContrato: any[] = []
  procedimentoOrigem: any[] = []
  situacao: any[] = []

  currentPage = 1
  pageSize = 10
  totalRows = 0

  tableBusy = false
  exibirModalAnulacao = false
  exibirModalImportacao = false
  idContratoSelecionado = 0
  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: 'plus',
      texto: 'Novo Contrato / OF',
      url: '/modulo-licitacoes/contratos/editar',
    },
    {
      id: 2,
      icone: 'file-upload',
      texto: 'Enviar Arquivo',
      acao: this.toggleModalImportacao
    }
  ]


  async mounted() {
    try {
      store.blockScreen = true
      const responseTipoContrato = await contratoService.listarTiposContrato()
      this.tipoContrato = [{ value: null, text: 'TODOS' }, ...responseTipoContrato.data.map(t => ({ value: t.IdTipoContrato, text: t.DeTipoContrato }))]
      const responseProcOrigem = await contratoService.listarProcedimentosOrigem()
      this.procedimentoOrigem = [{ value: null, text: 'TODOS' }, ...responseProcOrigem.data.map(t => ({ value: t.SgTipoProcedimentoOrigem, text: t.DeTipoProcedimentoOrigem }))]
      this.situacao = [{value: null, text: 'TODAS'}, {value: "EM", text: 'EM CADASTRAMENTO'}, {value: "FI", text: 'CADASTRADO'}, {value: "AN", text: 'ANULADO'}]

      await this.loadData()

    }
    catch (e) {
      console.error(e)
    }
    finally {
      store.blockScreen = false
    }

  }
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  async pageChange(value) {
    this.currentPage = value;
    await this.loadData();
  }

  async loadData(): Promise<void> {
    let response: any = null;
    response = await contratoService.filtrarCOFs(
      this.currentPage,
      this.pageSize,
      this.filtros
    );

    if (response) {
      this.totalRows = response.totalRows;

      this.items = response.contratosResumidos.map(function (p: any) {
        const retorno = new ContratoResumido(p)
        return retorno
      })
    } else {
      this.$toast.error("Erro ao obter a lista de contratos");
    }
    this.tableBusy = false;
  }

  async detalhesContrato(idContrato: number, excluir = false) {
      this.$router.push('/modulo-licitacoes/contratos/detalhes/' + idContrato + (excluir ? '?excluir' : ''))
  }
  async editarContrato(item: ContratoResumido) {
        this.$router.push('/modulo-licitacoes/contratos/editar/' + item.IdContrato)
  }
  /* async removerLicitacao(IdLicitacao) {
      console.log('call removerLicitacao', IdLicitacao)
      await this.sleep(2000)
    } */

  /**
   * chamado quando um COF é anulado, colapsa os detalhes e refaz a paginação.
   */
  atualizarLista(): void {
    this.loadData()
  }

  async limparFiltros() {
    //console.log('call limparFiltros')
    this.filtros.limpar();
  }
  async filtrarCOFs() {
    this.pageChange(1);
  }
  toggleModalAnulacao(idContrato) {
    if(!this.exibirModalAnulacao) {
      this.idContratoSelecionado = idContrato
    }
    else {
      this.idContratoSelecionado = 0
    }

    this.exibirModalAnulacao = !this.exibirModalAnulacao
  }
  toggleModalImportacao() {
    this.exibirModalImportacao = !this.exibirModalImportacao
  }
};
</script>

<style scoped></style>